<app-content-base [parent]="parent" [location]="location"
  [productCardWidgetTemplate]="munhowenProductCardWidgetTemplate">

  <!-- by using "context: {$implicit: { ... }}"" instead of "context: { ... }" you can bundle all parameters together and drop the names. Template and usage example below -->
  <!-- <ng-template #infoWidgetImplicitTemplate let-param>
    <app-widget-info [class]="param.class" [widget]="param.widget"></app-widget-info>
  </ng-template> -->

  <ng-template #munhowenProductCardWidgetTemplate let-class="class" let-widget="widget">
    <app-widget-product-card [class]="class" [widget]="widget"></app-widget-product-card>
  </ng-template>

</app-content-base>
